import getGlobalURL from "../../../assets/scripts/Global";
import {Fragment, React, useState} from 'react'
import axios from 'axios';
import PuffLoader from "react-spinners/PuffLoader";
import MemberListing from "./MemberListing";

const ManageMembersModal = (props) => {
    // ##################### URL change for Vercel##############################
    const url = getGlobalURL();
    if (url === "https://oceans-server-prod-v1.vercel.app") { axios.defaults.withCredentials = true; }
    // ##################### END OF URL change for Vercel#######################

    const [membersList, setMembersList] = useState(props.ocean.members);
    const [posting, setPosting] = useState(false); // Used for the spinner
    
    const handleRemoveMember = (memberID) => {
        console.log(memberID);
        let newMembersList = props.ocean.members
        newMembersList = newMembersList.filter((member) => {
            console.log(member);
            return member !== memberID;
        })
        console.log(newMembersList);
        props.ocean.members = newMembersList;
        setMembersList(newMembersList);
    }

    return (
        <div className='modal-container' >
            <div className='sg-backdrop' onClick={() =>  { props.closeModal('manageMembers') }}  />
            <div className="new-form-container">
                <div className="new-form-header">Manage Members</div>
                <div className="new-form-body">
                    <p className="form-instruction-text">In this form, you as an admin, may edit the permissions of each member.</p>
                    <hr className="hr-custom"/>
                    {posting ? (
                        <div style={{display: "flex", justifyContent: "center",alignItems: "center", height: "100%","margin-top": "15px"}}>
                            <PuffLoader color="#006994" />
                        </div>
                    ) : (
                        <div className='member-listing-container scrollbar-mch-thin' >
                            {membersList.map((memberID) => {
                                return (
                                    <Fragment key={memberID}>
                                        <MemberListing handleRemoveMember={handleRemoveMember} currentUser={props.currentUser} ocean={props.ocean} memberID={memberID} />
                                    </Fragment>
                                )
                            })}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ManageMembersModal
